import type { SnackbarProps } from '@osmosis/nextjs-components/Snackbar';

import dynamic from 'next/dynamic';

const SnackbarStatic = dynamic(
  async () => {
    const { Snackbar } = await import('@osmosis/nextjs-components/Snackbar');
    return Snackbar;
  },
  {
    ssr: false,
  },
);

/**
 * Snackbar component.
 */
const Snackbar = (props: SnackbarProps) => {
  return props?.isVisible ? <SnackbarStatic {...props} /> : null;
};

export default Snackbar;
